import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Link from 'next/link';
import { Box, Button, Divider, HStack, Text, VStack } from '@mybridge/ui';
import { GoogleMeetIcon } from '@mybridge/icons/GoogleMeetIcon';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const GoogleMeetingView = () => {
  const { googleMeetingDetails } = useSelector((state) => state.meeting);
  const { t } = useTranslator();
  const attendees = googleMeetingDetails?.extendedProps?.attendees;
  const [showRemainingAttendees, setShowRemainingAttendees] = useState(false);
  const [toggleSeeMore, setToggleSeeMore] = useState(true);

  const handleRemainingAttendees = () => {
    setShowRemainingAttendees(!showRemainingAttendees);
  };
  return (
    <>
      <Box className="row border-bottom">
        <VStack gap={3} alignItems="flex-start" mb={3}>
          <HStack gap={3}>
            <Text fontWeight="bold" w="100px">
              {t('profileMilestones.title') || "Title"}
            </Text>
            <Text fontWeight="normal">{googleMeetingDetails?.title}</Text>
          </HStack>
          <HStack gap={3}>
            <Text fontWeight="bold" w="100px">
              {t('meeting.host') || "Host"}
            </Text>
            <Text fontWeight="normal">
              {googleMeetingDetails?.extendedProps?.created_by?.email}
            </Text>
          </HStack>
          {googleMeetingDetails?.extendedProps?.attendees?.length ? (
            <HStack gap={3} alignItems="flex-start">
              <Text fontWeight="bold" w="100px">
                {t('eventDashboard.attendees') || "Attendees"}
              </Text>
              <Text fontWeight="normal">
                {!showRemainingAttendees ? (
                  <>
                    {googleMeetingDetails?.extendedProps?.attendees
                      ?.map((user) => user.email)
                      ?.slice(0, 4)
                      ?.join(', ')}
                    and
                    {attendees?.length > 4 ? (
                      <Box as="span" onClick={handleRemainingAttendees}>
                        +{attendees?.length - 4} {t('navigation.more') || "more"}
                      </Box>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  <>
                    {googleMeetingDetails?.extendedProps?.attendees
                      ?.map((user) => user.email)
                      ?.join(', ')}{' '}
                    <Box as="span" onClick={handleRemainingAttendees}>
                      - {t('publicProfile.showLess') || "show less"}
                    </Box>
                  </>
                )}
              </Text>
            </HStack>
          ) : (
            <></>
          )}
          <HStack gap={3}>
            <Text fontWeight="bold" w="100px">
              {t(`scheduling.when`) || "When"}
            </Text>
            <Text fontWeight="normal">
              {moment(googleMeetingDetails?._instance?.range?.start).format(
                'ddd, MMM DD, YYYY hh:mm A'
              )}{' '}
              to{' '}
              {moment(googleMeetingDetails?._instance?.range?.end).format(
                'hh:mm A'
              )}
            </Text>
          </HStack>
          {googleMeetingDetails?.extendedProps?.location && (
            <HStack gap={3}>
              <Text fontWeight="bold" w="100px">
                {t('profileDetails.location') || "Location"}
              </Text>
              <Text fontWeight="normal">
                <Link target='_blank' rel="nofollow" href={googleMeetingDetails?.extendedProps?.location_url?googleMeetingDetails?.extendedProps?.location_url:googleMeetingDetails?.extendedProps?.location}>
                  {googleMeetingDetails?.extendedProps?.location_url?googleMeetingDetails?.extendedProps?.location_url:googleMeetingDetails?.extendedProps?.location}
                </Link>
              </Text>
            </HStack>
          )}
          <HStack gap={3}>
            <Text fontWeight="bold" w="100px">
              {t('myCalendar.description') || "Description"}
            </Text>
            <Text fontWeight="normal" className="jobDetailsDescription" dangerouslySetInnerHTML={{
            __html: googleMeetingDetails?.extendedProps?.description,
          }} />
          </HStack>
          {/* {googleMeetingDetails?.id && (
        <HStack gap={3}>
          <Text fontWeight="bold" w="100px">Meeting ID</Text>
          <Text fontWeight="normal">
            {googleMeetingDetails?.id}{' '}
   
          </Text>
          </HStack>
      )} */}

        </VStack>
      <Divider mb={4    }/>            
        {googleMeetingDetails?.extendedProps?.location==="google_meet" && (
              <HStack gap={5} mb="20px" alignItems="center" justifyContent="space-between">
               < HStack alignItems="flex-start" justifyContent="flex-start"> 
                 <GoogleMeetIcon width="24px" height="24px"/>
                <Box>
                <Text fontWeight="500" fontSize="16px" lineHeight="20.8px" color="#747474">{t('scheduling.joinWithGoogleMeet') || "Join with Google meet"}</Text>  
                  <Text color="#548BFC" cursor="pointer"  onClick={() => window.open(googleMeetingDetails?.extendedProps?.location_url)} fontSize="14px">{googleMeetingDetails?.extendedProps?.location_url}</Text>
                </Box>
                </HStack>
               {googleMeetingDetails?.extendedProps?.location_url&&<Button
                    variant="primary"
                    onClick={() => window.open(googleMeetingDetails?.extendedProps?.location_url)}
                  >
                    {t('scheduling.joinMeeting') || "Join Meeting"}
                  </Button>}
              </HStack> 
            )}
      </Box>
      
    </>
  );
};

export default GoogleMeetingView;
